import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/hostelWorldActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchHwOrganizations = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.HW_ORGANIZATIONS_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.hwOrganizations, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.hw_fetchOrganizationsSuccess(getParser(urls.hwOrganizations)(json))))
        .catch(
            handleError(
                dispatch,
                actions.hw_fetchOrganizationsFailure,
                'Что-то пошло не так!',
                'При получении организаций произошла ошибка'
            )
        )
}

/** @thunk **/
export const postHwOrganization = organization => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(organization)
    }
    const { auth } = getState()

    securedFetch(urls.hwOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.hw_saveOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация добавлена'))
        .catch(
            handleError(
                dispatch,
                actions.hw_saveOrganizationsFailure,
                'Что-то пошло не так!',
                'При сохранении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const updateHwOrganization = (remoteId, payload) => (dispatch, getState) => {
    // prettier-ignore
    const { auth, hwOrganizations: { entities: { organizations } } } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...organizations[remoteId], ...payload })
    }

    securedFetch(urls.hwOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.hw_updateOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация обновлена'))
        .catch(
            handleError(
                dispatch,
                actions.hw_updateOrganizationsFailure,
                'Что-то пошло не так!',
                'При обновлении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteHwOrganization = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.hwOrganizationSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.hw_deleteOrganizationSuccess(remoteId)))
        .then(() => toastr.success('Организация удалена'))
        .catch(
            handleError(
                dispatch,
                actions.hw_deleteOrganizationFailure,
                'Что-то пошло не так!',
                'При удалении организации произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/hostelWorldApi/hwOrganizations.js